// react
import React, { Fragment, useEffect, useReducer, useState } from 'react';
// redux
import { useSelector } from 'react-redux';
// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { Message } from '../../../components/message';
// reducer
import {
  dashboardStatesInitialState,
  dashboardStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

// services
import { uploadStudentsDataService } from '../../../services/adminService';
import {
  getFacultiesService,
  getFacultyInfoService,
} from '../../../services/universityStructureService';
import { getRoleService } from '../../../services/adminService';
// router
import { useNavigate } from 'react-router-dom';

/***************************************************************************/
/* Name : UploadStudentInfoPage React Component */
/***************************************************************************/
const UploadStudentInfoPage = React.memo(() => {
  const navigate = useNavigate();
  // faculty
  const [facultySelected, setFacultySelected] = useState('اختر الكلية');
  const [facultiesData, setFacultiesData] = useState([]);
  //status
  const [statusSelected, setStatusSelected] = useState('اختر الحالة');
  const [statusData, setStatusData] = useState(['انتظام', 'انتساب', 'لا يوجد']);
  // file state
  const [file, setFile] = useState(null);
  // reducer
  const [dashboardStates, dispatchDashboardStates] = useReducer(
    dashboardStatesReducer,
    dashboardStatesInitialState
  );
  // Role state
  const [role, setRole] = useState('NOT');
  // faculty info state
  const [facultyInfo, setFacultyInfo] = useState({});
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // get faculties
      await getFacultiesHandler();
      // dispatch pending
      dispatchDashboardStates({ type: 'PENDING' });

      // get role
      const { role } = await getRoleService();
      if (role !== undefined) {
        setRole(role);
      }

      dispatchDashboardStates({ type: 'CLEAR' });
    })();
  }, []);
  /******************************************************************/
  /* get facutlies */
  /******************************************************************/
  const getFacultiesHandler = async () => {
    // get faculties
    const response = await getFacultiesService();
    if (response.status === 'success') {
      // set faculties
      setFacultiesData(response.data);
    }
  };
  /******************************************************************/
  /* uploadStudentDataHandler*/
  /******************************************************************/
  const uploadStudentDataHandler = async (e) => {
    // prevent default
    e.preventDefault();
    dispatchDashboardStates({ type: 'PENDING' });

    // check if the user not select faculty return error
    if (facultySelected === 'اختر الكلية') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'يجب اختيار الكلية',
      });
      return;
    }

    // check if the user not select file return error
    if (!file) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'يجب اختيار ملف الطلاب',
      });
      return;
    }

    if (
      file.name.split('.')[1] !== 'xlsx' &&
      file.name.split('.')[1] !== 'xls'
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'يجب اختيار ملف اكسيل فقط',
      });
      return;
    }
    // get data
    const data = {
      faculty: facultySelected,
      status:
        (statusSelected === 'انتظام') |
        (statusSelected === 'انتساب') |
        (statusSelected === 'لا يوجد')
          ? statusSelected
          : '',
      file: file,
    };
    // upload student data
    const response = await uploadStudentsDataService(data);
    if (response.status === 'success') {
      dispatchDashboardStates({
        type: 'SUCCESS',
        successMessage: response.data,
      });
    } else {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: response.message,
      });
    }
  };
  // snackbar state
  const handleCloseSnackbar = () => {
    dispatchDashboardStates({ type: 'CLEAR' });
  };

  return (
    <Fragment>
      <NavHeader title='رفع بيانات الطلاب' />
      {(role === 'SUPERADMIN' || role === 'SUPPORT') && (
        <form
          className={styles['nav-input']}
          onSubmit={uploadStudentDataHandler}
        >
          <div className={styles['form-control']}>
            <select
              id='faculty'
              name='faculty'
              value={facultySelected}
              onChange={(e) => {
                setFacultySelected(e.target.value);
              }}
            >
              <option value={'اختر الكلية'}>اختر الكلية</option>
              {facultiesData.map((el) => (
                <option value={el} key={el}>
                  {el}
                </option>
              ))}
            </select>
          </div>
          <div className={styles['form-control']}>
            <select
              id='status'
              name='status'
              value={statusSelected}
              onChange={(e) => {
                setStatusSelected(e.target.value);
              }}
            >
              <option value={'اختر الحالة'}>اختر الحالة</option>
              {statusData.map((el) => (
                <option value={el} key={el}>
                  {el}
                </option>
              ))}
            </select>
          </div>
          <div className={styles['form-control']}>
            <input
              type='file'
              name='file'
              id='file'
              className={styles['inputfile']}
              dir='ltr'
              accept='.xls,.xlsx'
              onChange={(e) => {
                setFile(e.target.files[0]);
                // get file name
              }}
            />
            <div className={styles['upload-btn']}>
              <label htmlFor='file'>اختر ملف</label>
              <p>{file ? file.name : 'لم يتم اختيار ملف'}</p>
            </div>
          </div>

          {!dashboardStates.pending && <button>رفع البيانات</button>}
          {dashboardStates.pending && (
            <button>
              <CircularProgress
                size={20}
                sx={{
                  color: '#a18a00',
                }}
              />
            </button>
          )}
        </form>
      )}
      {role === 'ADMIN' && role !== 'NOT' && (
        <Message text='لا يمكنك الوصول لهذه الصفحة' type='error' />
      )}
      {/* ********** SUCESS SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.success}
        autoHideDuration={10000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity='success'
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#388E3C',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          {dashboardStates.successMessage}!
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { UploadStudentInfoPage };
